import 'Plugins/responsiveHelper';
import 'Plugins/tabsPlugin';
import 'Plugins/responsiveHelper';
import 'Plugins/accordionPlugin';
import 'Plugins/inViewportPlugin';

export default function initLocations() {
  jQuery('.lenders').each(function() {
    var holder = jQuery(this);
    var accordion = holder.find('.accordion-mobile');
    var tabset = holder.find('.tabset');
    var tabsetApi, accordionApi, activeElem = null;
    var blocks = holder.find('.tab:not(.all-lenders)')

    var locations = {};
    var geocoder = new google.maps.Geocoder();
    var coord = null;

    var form = jQuery('.lenders-search-form');
    var select = form.find('#locations-select');
    var searchEl = form.find('#search');

    blocks.each(function(i, block) {
      var elem = jQuery(block);
      var id = elem.attr('id');
      var items = elem.find('.lender-item');

      items.each(function(i, el) {
        var item = jQuery(el);
        locations[id] = [];


        if (item.attr('data-coords')) {
          locations[id].push(JSON.parse(item.attr('data-coords')));
        }
      });
    });

    function setActiveSlide(selector) {
      var active = jQuery(selector);
      active.find('> a.opener').trigger('click');
    }

    function setActiveTab(selector) {
      tabsetApi.$tabLinks.each(function(i, link){
        var a = jQuery(link);
        if (a.attr('href') === selector) a.trigger('click');
      });
    }

    function toRad(value) {
      return (value * Math.PI) / 180;
    }

    function calculateDistance(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var dLat = toRad(lat2 - lat1);
      var dLon = toRad(lng2 - lng1);
      var l1 = toRad(lat1);
      var l2 = toRad(lat2);

      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(l1) * Math.cos(l2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    }

    function getNearestTab() {
      var distance = 999999999999;
      var currTab = null;

      Object.entries(locations).forEach(function(entry) {
        var key = entry[0];
        var currentArr = entry[1]

        currentArr.forEach(function(currCoords) {
          var currDistance = calculateDistance(currCoords.lat, currCoords.lang, coord.lat, coord.lng);

          if (currDistance < distance) {
            distance = currDistance;
            currTab = key;
          }
        });
      })

      return currTab;
    }

    var submitHandler = (e) => {
      e.preventDefault();
      var activeTab = select.val();
      var search = searchEl.val().trim();

      if (search && geocoder) {
        geocoder.geocode({'address': search}, function(results, status) {
          if (status == 'OK') {
            coord = {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            }

            var tab = getNearestTab();

            if (tab && tabsetApi) setActiveTab(`#${tab}`);
            if (accordion && accordionApi) setActiveSlide(`#${tab}`);
          } else {
            alert('Geocode was not successful for the following reason: ' + status);
          }
        });
      } else if (!search) {
        if (tabsetApi) setActiveTab(activeTab);
        if (accordionApi) setActiveSlide(activeTab);
      }

      return false;
    }

    form.on('submit', submitHandler);

    ResponsiveHelper.addRange({
      '1024..': {
        on: function() {
          if (accordionApi) {
            accordion.slideAccordion('destroy');;
            accordionApi = null;
          }

          tabset.tabset({
            tabLinks: 'a',
            defaultTab: false,
            onInit: function(self) {
              tabsetApi = self;

              if (activeElem) setActiveTab(activeElem);
            },
            onChange: function() {
              activeElem = tabsetApi.$tabLinks[tabsetApi.activeTabIndex].getAttribute('href');
            }
          });
        }
      },
      '..1023': {
        on: function() {
          if (tabsetApi) {
            tabset.tabset('destroy');
            tabsetApi = null;
          }

          accordion.slideAccordion({
            opener: '.opener',
            slider: '.slide',
            animSpeed: 300,
            collapsible: false,
            scrollToElemAlways: true,
            scrollToActiveItem: {
              enable: true,
              extraOffset: 0,
              breakpoint: 1023,
            },
            onInit: function(self) {
              accordionApi = self;
              if (activeElem) setActiveSlide(activeElem);
            },
            onShow: function(item) {
              activeElem = `#${item.attr('id')}`;
            }
          });
        }
      }
    });
  });
}
